module.exports = __webpack_public_path__ + "img/expert-2.aa08b00d.png";